namespace $.$$ {
	export class $shm_textarea_code_line extends $.$shm_textarea_code_line {
		@ $mol_mem
		sub() {
			// One minified/generated line cannot be windowed by logical line number.
			// Keep it editable without constructing hundreds of thousands of tokens.
			if( this.text().length > 64 * 1024 ) return [
				... this.numb_showed() ? [this.Numb()] : [],
				this.text(),
			]
			return super.sub()
		}
	}
}
